import { render } from "./gqUploadView.vue?vue&type=template&id=b9e3c16c"
import script from "./gqUploadView.vue?vue&type=script&lang=js"
export * from "./gqUploadView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__